"use strict";

exports.__esModule = true;
exports.ComparisonOperatorSelector = ComparisonOperatorSelector;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Translator = require("../../Core/Translator");
var _Selector = require("../../Core/Selector");
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Placeholder = _styledComponents["default"].em.withConfig({
  displayName: "ComparisonOperatorSelector__Placeholder",
  componentId: "sc-fku6mu-0"
})(["user-select:none;display:inline-flex;flex-direction:row;align-items:center;justify-content:center;padding:5px 10px;text-align:left;font-size:14px;min-width:30px;min-height:30px;border-top:1px solid ", ";border-bottom:1px solid ", ";"], (0, _Theme.val)("borderColor"), (0, _Theme.val)("borderColor"));
function getKey(input) {
  return input.id;
}
function renderItemText(input) {
  return input.label;
}

/**
 * Allows a user to select metric(s) from a list.
 * Used in lib-ui-knowledge-base
 */
function ComparisonOperatorSelector(props) {
  var _props$items = props.items,
    items = _props$items === void 0 ? ["=", ">", "<"] : _props$items;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    var getItemLabel = function getItemLabel(id) {
      if (id === "=") {
        return translate("ComparisonOperatorSelector.itemLabel.equals", "equals");
      } else if (id === ">") {
        return translate("ComparisonOperatorSelector.itemLabel.greaterThan", "greater than");
      } else if (id === "<") {
        return translate("ComparisonOperatorSelector.itemLabel.lessThan", "less than");
      }
      return id;
    };
    if (items.length === 1) {
      return /*#__PURE__*/_react["default"].createElement(Placeholder, null, getItemLabel(items[0]));
    }
    return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
      noResults: translate("ComparisonOperatorSelector.noResults", "No Operators."),
      placeholder: translate("ComparisonOperatorSelector.placeholder", "Select Operator"),
      getKey: getKey,
      renderItemText: renderItemText
    }, props, {
      filterable: false,
      onSelect: function onSelect(selected) {
        props.onSelect(selected.map(getKey));
      },
      multiple: false,
      items: items.map(function (id) {
        return {
          id: id,
          label: getItemLabel(id)
        };
      })
    }));
  });
}